module.exports = __webpack_public_path__ + "static/forum-illustration.48f92e33.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Location/forum-illustration.png
// module id = 700
// module chunks = 213534597649335